document.addEventListener("DOMContentLoaded", function () {
  const sitewideSearchInput = document.getElementById("SearchControl_SearchTerm");
  if (sitewideSearchInput) {
    sitewideSearchInput.setAttribute("placeholder", "Search the community");
  }
});
